import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import DcReturnModal from "../components/dcReturnsModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const AddDcReturn = () => {
    useAuthRedirect();
    const [showModal, setShowModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const branch = localStorage.getItem("branch");
    const user = localStorage.getItem("username");
    const [dcNumber, setDcNo] = useState(null);
    const [poNumber, setPoNo] = useState("");
    const [hoDetails, setHoDetails] = useState({});
    const [formData, setFormData] = useState({});
    const navigate = useNavigate();
    const canEntry = hasPermission("D.C Returns", "entry");

    useEffect(() => {
        const fetchPoNo = async () => {
            try {
                const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/dcReturn_no?branch=${branch}`);
                if (response.data.PoNo) {
                    const NewPo = parseInt(response.data.PoNo, 10) || 0;
                    setPoNo(NewPo.toString());
                    setFormData((prevState) => ({
                        ...prevState,
                        PoNumber: NewPo.toString(),
                    }));
                }
            } catch (error) {
                console.error("Error fetching indent number:", error);
            }
        };
        fetchPoNo();
    }, [branch]);

    const handleSelectItem = async (supplier) => {
        try {
            setDcNo(supplier.dcdetail_number);
            const response = await axios.get(
                "https://rfs2.infraconsoft.net.in/api/dcReturns_fetchData",
                {
                    params: {
                        num: supplier.dcdetail_number,
                        branch : branch,
                    },
                });
            if (response.data.length > 0) {
                setSelectedItems(response.data);
            }
            console.log(response.data);
            
        } catch (error) {
            console.error("Error fetching supplier items:", error);
        }
    };

    const removeRow = (index) => {
  setSelectedItems(prev => prev.filter((_, i) => i !== index));
};


    useEffect(() => {
        const fetchDcReturnsHeader = async () => {
            try {
                const response = await axios.get(
                    `https://rfs2.infraconsoft.net.in/api/dcReturn_fetchHeader?dcNo=${dcNumber}&branch=${branch}`
                );
                const items = response.data.headerDetails;

                const dReutnsHeader = {
                    dcNumber: items[0].dcheader_number,
                    branch: items[0].branchCode,
                    dcDate: items[0].dcheader_date,
                    type: items[0].dcheader_type,
                    scode: items[0].dcheader_supplierCode,
                    sName: items[0].dcheader_supplierName,
                    refNo: items[0].dcheader_yourReferenceNumber,
                    refDate: items[0].dcheader_yourReferenceDate,
                    pack: items[0].dcheader_noofPacks,
                    vno: items[0].dcheader_vehicleNumber,
                    remarks: items[0].dcheader_remarks,
                    address: items[0].dcheader_address,
                    city: items[0].dcheader_city,
                    pincode: items[0].dcheader_pincode,
                    phone: items[0].dcheader_phone,
                    email: items[0].dcheader_mobile,
                };
                setHoDetails(dReutnsHeader);
            } catch (error) {
                console.error("Error fetching locations:", error);
            }
        };

        fetchDcReturnsHeader();
    }, [dcNumber, branch]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleRowChange = (index, field, value) => {
        setSelectedItems((prevItems) =>
          prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
        );
      };

const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Check if no items selected
  if (selectedItems.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

  // ✅ Validate urDcNo
  if (!formData.urDcNo || formData.urDcNo.trim() === "") {
    Swal.fire("Error", "Enter UR DC Number!", "error");
    return;
  }

  // ✅ Validate urDcDate
  if (!formData.urDcDate || formData.urDcDate.trim() === "") {
    Swal.fire("Error", "Enter UR DC Date!", "error");
    return;
  }

  // ✅ Validate recQty for each item
for (let i = 0; i < selectedItems.length; i++) {
  const item = selectedItems[i];
  
  // Check if qty is a valid number
  if (
    item.qty === undefined ||
    item.qty === null ||
    item.qty === "" ||
    isNaN(item.qty)
  ) {
    Swal.fire(
      "Error",
      `Received Qty must be a number for item: ${item.dcdetail_ItemName}`,
      "error"
    );
    return;
  }

  const recQty = Number(item.qty);
  const pendingQty = item.dcdetail_quantity - item.dcdetail_receivedQuantity;

  // Check if qty is greater than 0
  if (recQty <= 0) {
    Swal.fire(
      "Error",
      `Received Qty should be greater than 0 for item: ${item.dcdetail_ItemName}`,
      "error"
    );
    return;
  }

  // ✅ New check: recQty should not exceed pendingQty
  if (recQty > pendingQty) {
    Swal.fire(
      "Error",
      `Received Qty (${recQty}) cannot be greater than pending Qty (${pendingQty}) for item: ${item.dcdetail_ItemName}`,
      "error"
    );
    return;
  }
}

// ✅ Build payload
const payload = {
  dcReturnNo: poNumber,
  branch: branch,
  user: user,
  supplierCode: hoDetails.scode,
  supplierName: hoDetails.sName,
  type: hoDetails.type,
  urDcNo: formData.urDcNo,
  urDcDate: formData.urDcDate,
  ourDcNo: hoDetails.dcNumber,
  ourDcDate: hoDetails.refDate,
  pack: hoDetails.pack,
  vno: hoDetails.vno,
  remarks: formData.remarks,
  address: hoDetails.address,
  city: hoDetails.city,
  pincode: hoDetails.pincode,
  phone: hoDetails.phone,
  email: hoDetails.email,
  items: selectedItems.map((item) => {
    const pendingQty =
      item.dcdetail_quantity - item.dcdetail_receivedQuantity;

    return {
      itemCode: item.dcdetail_itemcode,
      itemName: item.dcdetail_ItemName,
      itemUom: item.dcdetail_uom,
      pendingQty: pendingQty,
      recQty: Number(item.qty),
    };
  }),
};

  console.log(payload);

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await axios.post("https://rfs2.infraconsoft.net.in/api/dcReturn_insert", payload);

    Swal.fire("Success", "DC Return Added successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/dcReturnView");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};

if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

    return (
        <div id="admin-container">
            <InventoryNav />
            <div className="content-right">
                <section>
                    <div className="back-div">
                                        <h2 className="add-txt">D.C. Returns - Add</h2>
                                        <Link to='/inventory/dcReturnView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                        </div>
                    <Time />
                </section>

                <div className="form-container">
                    <form className="vehicle-form" onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>D.C Return No :</label>
                                <input type="text" name="PoNumber" value={poNumber} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Date :</label>
                                <input type="date" name="endhrs"value={new Date().toISOString().split("T")[0]} readOnly />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Type :</label>
                                <input type="text" name="PoNumber" value={hoDetails.type} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Party Name :</label>
                                <input type="text" name="sname" value={hoDetails.sName} />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Your D.C No :</label>
                                <input type="text" name="urDcNo" value={formData.urDcNo} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label>Your D.C Date :</label>
                                <input type="date" name="urDcDate" value={formData.urDcDate} onChange={handleChange}/>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Our D.C No :</label>
                                <input type="text" name="dcNumber" value={hoDetails.dcNumber} onChange={handleChange} readOnly/>
                            </div>
                            <div className="form-group">
                                <label>Our D.C Date :</label>
                                <input type="text" name="ourRefDate" value={new Date(hoDetails.dcDate).toLocaleDateString("en-GB")} readOnly />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Vehicle Number :</label>
                                <input type="text" name="vno" value={hoDetails.vno} />
                            </div>
                            <div className="form-group">
                                <label>No. Of Packs :</label>
                                <input type="text" name="pack" value={hoDetails.pack}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Address :</label>
                                <input type="text" name="address" value={hoDetails.address} />
                            </div>
                            <div className="form-group">
                                <label>City :</label>
                                <input type="text" name="city" value={hoDetails.city}  />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Pin Code :</label>
                                <input type="text" name="pincode" value={hoDetails.pincode} />
                            </div>
                            <div className="form-group">
                                <label>Phone :</label>
                                <input type="text" name="phone" value={hoDetails.phone}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Email :</label>
                                <input type="text" name="email" value={hoDetails.email}
                                />
                            </div>
                            <div className="form-group">
                                <label>Remarks :</label>
                                <input type="text" name="remarks" value={formData.remarks} onChange={handleChange}/>
                            </div>
                        </div>

                        <div className="flex_buttons">
                            <button
                                type="button"
                                className="button button-add"
                                onClick={() => setShowModal(true)}
                            >
                                Select Pending
                            </button>
                        </div>

                        <div className="content-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Item</th>
                                        <th>Description</th>
                                        <th>UOM</th>
                                        <th>Pending Qty</th>
                                        <th>Rec Qty</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedItems.length > 0 ? (
                                        selectedItems.map((item, index) => {
                                            const pendingQty = item.dcdetail_quantity - item.dcdetail_receivedQuantity;

                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.dcdetail_itemcode}</td>
                                                    <td>{item.dcdetail_ItemName}</td>
                                                    <td>{item.dcdetail_uom}</td>
                                                    <td>{pendingQty}</td>
                                                    <td>
                                                    <input type="text" value={item.qty} onChange={(e) => handleRowChange(index, "qty", e.target.value)}/>
                                                    </td>
                                                    <td className="del">
                          <i
                            className="fa-solid fa-trash-can"
                            title="Remove this row (temporary)"
                            onClick={() => removeRow(index)}
                            style={{ cursor: "pointer" }}
                          ></i>
                        </td>
                                                
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="10">No items added</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="btn-cls">
                            <button type="submit" className="submit-btn">
                                Checkout
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <DcReturnModal
                showModal={showModal}
                closeModal={() => setShowModal(false)}
                branch={branch}
                onSelectItem={handleSelectItem}
            />
        </div>
    );
};

export default AddDcReturn;
